import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown, Form } from 'semantic-ui-react';

const hoursOptions = Array.from({ length: 12 }, (_, i) => {
  const value = (i + 1).toString().padStart(2, '0'); // 01–12
  return {
    key: value,
    text: value,
    value
  };
});

const minutesOptions = Array.from({ length: 60 }, (_, i) => {
  const value = i.toString().padStart(2, '0');
  return {
    key: value,
    text: value,
    value
  };
});

const amPmOptions = [
  { key: 'AM', text: 'AM', value: 'AM' },
  { key: 'PM', text: 'PM', value: 'PM' }
];

const to12Hour = (hour24) => {
  const h = parseInt(hour24, 10);

  if (h === 0) return { hour: '12', amPm: 'AM' };
  if (h === 12) return { hour: '12', amPm: 'PM' };
  if (h > 12) return { hour: (h - 12).toString().padStart(2, '0'), amPm: 'PM' };

  return { hour: h.toString().padStart(2, '0'), amPm: 'AM' };
};

const to24Hour = (hour12, amPm) => {
  let h = parseInt(hour12, 10);

  if (amPm === 'AM') {
    return h === 12 ? 0 : h;
  }

  return h === 12 ? 12 : h + 12;
};

export const TimeSelector = ({
  fip,
  itemProp,
}) => {

  const originalTime = useMemo(() => {
    if (fip?.value) {
      const [hour24, minute] = fip.value.split(':');
      const { hour, amPm } = to12Hour(hour24);
      return {
        hour,
        minute: minute?.padStart(2, '0') || '00',
        amPm
      }
    }
  }, [])

  const [currentTime, setCurrentTime] = useState({
    hour: originalTime?.hour || '00',
    minute: originalTime?.minute || '00',
    amPm: originalTime?.amPm || 'AM'
  });

  const { display, prop } = itemProp ?? {}
  const { caption } = display ?? {}

  const _caption = caption || _.startCase(prop)

  useEffect(() => {
    if (currentTime) {
      const currentValue = `${hour24}:${currentTime.minute}`;
      const data = {
        propname: fip.propname,
        value: currentValue
      }
      fip?.onChange && fip.onChange(null, data)
    }
  }, [currentTime]);

  const handleChange = (field) => (e, { value }) => {
    setCurrentTime(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // 24-hour value to save when OK is clicked
  const hour24 = to24Hour(currentTime.hour, currentTime.amPm)
    .toString()
    .padStart(2, '0');

  return (
    <Form style={{ padding: '0 0 .5em 0' }} className='mlc'>
      <div className='field'>
        <label>
          {`${_caption}`}
        </label></div>
      <Form.Group widths='equal' style={{ margin: '0, 0, .5em 0' }}>
        <Form.Field style={{ paddingLeft: 0 }} >
          <Dropdown
            fluid
            selection
            placeholder='HH'
            options={hoursOptions}
            value={currentTime?.hour}
            onChange={handleChange('hour')}
          />
        </Form.Field>

        <Form.Field style={{ paddingRight: 0, paddingLeft: 0 }} >
          <Dropdown
            fluid
            selection
            placeholder='MM'
            options={minutesOptions}
            value={currentTime?.minute}
            onChange={handleChange('minute')}
          />
        </Form.Field>

        <Form.Field style={{ paddingRight: 0 }}>
          <Dropdown
            fluid
            selection
            options={amPmOptions}
            value={currentTime?.amPm}
            onChange={handleChange('amPm')}
          />
        </Form.Field>
      </Form.Group>
    </Form>
  );
};
